import React from 'react';
import { Button } from '@xingternal/button';
import type { ButtonInternal } from '../../typings/types';

type PropsButtonsContainer = {
  buttons: ButtonInternal[];
  className?: string;
  style?: React.CSSProperties;
};
type Props = React.PropsWithChildren<PropsButtonsContainer>;

const ButtonsContainer = ({ buttons, ...props }: Props) => (
  <div {...props}>
    {buttons.map((button, index: number) => (
      <Button {...button} key={index} />
    ))}
  </div>
);

export default ButtonsContainer;
